<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="700"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon flat class="mr-2"
               @click="dialog = true">
          <v-icon color="grey darken-1">mdi-eye</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          <span>{{ dispatch.title }}</span>
        </v-card-title>

        <v-card-text>
          Despacho:
          <blockquote class="blockquote elevation-1" v-html="dispatch.text"/>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            flat
            @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'PreviewDispatch',
  props: ['dispatch'],
  data(){
    return {
      dialog: false,
    }
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
  .blockquote{
    border-radius: 3px !important;
    background: #f5f5f5 !important;
  }

  .v-card__title{
    background-color: #4185f4;

    span {
      color: white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/dispatches/PreviewDispatch.vue